<template>
  <div class="about">
    <h1>You can contact me at Linkedin.</h1>
  </div>
</template>
